import { apiClient, toServiceError } from '@/services/http/client'
import type {
  RulePackComparison,
  RulePackDetail,
  RulePackSummary,
  RulePackValidation,
} from '@/types/rulePack.types'

async function safe<T>(operation: () => Promise<T>): Promise<T> {
  try {
    return await operation()
  } catch (error) {
    throw toServiceError(error)
  }
}

export const rulePacksHttp = {
  list: () => safe(async () => (await apiClient.get<RulePackSummary[]>('/rule-packs')).data),
  get: (packId: string) =>
    safe(async () => (await apiClient.get<RulePackDetail>(`/rule-packs/${packId}`)).data),
  compare: (leftPackId: string, rightPackId: string) =>
    safe(async () => (
      await apiClient.get<RulePackComparison>(`/rule-packs/${leftPackId}/compare/${rightPackId}`)
    ).data),
  validate: (packId: string) =>
    safe(async () => (
      await apiClient.post<RulePackValidation>(`/rule-packs/${packId}/validate`)
    ).data),
  approve: (packId: string, manifestChecksum: string, reason: string) =>
    safe(async () => (
      await apiClient.post<RulePackDetail>(
        `/rule-packs/${packId}/approve`,
        { expected_manifest_checksum: manifestChecksum, reason },
        { headers: { 'Idempotency-Key': crypto.randomUUID() } },
      )
    ).data),
  withdraw: (packId: string, manifestChecksum: string, reason: string) =>
    safe(async () => (
      await apiClient.post<RulePackDetail>(
        `/rule-packs/${packId}/withdraw`,
        { expected_manifest_checksum: manifestChecksum, reason },
        { headers: { 'Idempotency-Key': crypto.randomUUID() } },
      )
    ).data),
}
